// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  CampaignField as Field,
  CampaignFieldset as Fieldset,
  CampaignMultiSelectInputField as MultiSelectField,
  CampaignPage as Page,
  CampaignSingleSelectInputField as SingleSelectField,
} from '@fmnts/api/next';
import * as Arr from 'effect/Array';
import * as Brand from 'effect/Brand';
import { ReadonlyRecord } from 'effect/Record';

export { Field, Fieldset, MultiSelectField, Page, SingleSelectField };

/** Unsanitized form data. */
export type UnpreparedFormData = ReadonlyRecord<string, unknown>;
/** Sanitized form data. */
export type Payload = ReadonlyRecord<string, unknown> &
  Brand.Brand<'CampaignForm.Payload'>;
export const Payload = Brand.nominal<Payload>();

/**
 * @param pages The form pages
 *
 * @returns
 * Array of form fields extracted from the given form pages
 */
export function getFieldsOnPage(page: Page): ReadonlyArray<Field> {
  return Arr.flatMap(page.fieldsets, (p) => p.fields);
}
